export default {
  namespaced: true,
  state: {
    arbSubmitInProgress: false,
    complaintSection: {},
    complaintQuestion: {},
    complaints: [],
    odometerInput: null,
    activeComplaint: {
      sectionId: 0,
      questionId: 0,
      questionTitle: '',
    },
  },
  mutations: {
    setDefaultState(state) {
      state.arbSubmitInProgress = false;
      state.complaintSection = {};
      state.complaintQuestion = {};
      state.complaints = [];
      state.odometerInput = null;
      state.activeComplaint = {
        sectionId: 0,
        questionId: 0,
        questionTitle: '',
      };
    },
    setArbSubmitInProgress(state, value) {
      state.arbSubmitInProgress = value;
    },
    setComplaintSection(state, payload) {
      state.complaintSection = payload;
    },
    setComplaintQuestion(state, payload) {
      state.complaintQuestion = payload;
    },
    setOdometerInput(state, value) {
      state.odometerInput = value;
    },
    upsertComplaint(state, payload) {
      const index = state.complaints.findIndex((x) => x.questionId === payload.questionId);
      if (index > -1) {
        state.complaints.splice(index, 1, payload);
      } else {
        state.complaints.push(payload);
      }
    },
    removeComplaint(state, value) {
      const index = state.complaints.findIndex((x) => x.questionId === value);
      if (index > -1) {
        state.complaints.splice(index, 1);
      }
    },
    moveUploadedEvidence(state, complaint) {
      // adds uploadedEvidence into evidences then resets uploads to default
      const index = state.complaints.findIndex((x) => x.complaintId === complaint.complaintId);
      if (index > -1) {
        state.complaints[index].evidenceUploads.forEach((evidence) => {
          state.complaints[index].evidences.push({
            evidenceId: null,
            url: evidence.url,
            fileName: evidence.filename,
          });
        });
        state.complaints[index].evidenceUploads = [];
      }
    },
    setActiveComplaint(state, payload) {
      // sets the current section and question data for the complaint form, edits, and deletes
      // reduces need to pass around data via events in nested children components
      state.activeComplaint.sectionId = payload.sectionId;
      state.activeComplaint.questionId = payload.questionId;
      state.activeComplaint.questionTitle = payload.questionTitle;
    },
  },
  actions: {
    setDefaultState({ commit }) {
      commit('setDefaultState');
    },
    setArbSubmitInProgress({ commit }, value) {
      commit('setArbSubmitInProgress', value);
    },
    setComplaintSection({ commit }, section) {
      commit('setComplaintSection', section);
    },
    setComplaintQuestion({ commit }, question) {
      commit('setComplaintQuestion', question);
    },
    setOdometerInput({ commit }, value) {
      commit('setOdometerInput', value);
    },
    upsertComplaint({ commit }, payload) {
      commit('upsertComplaint', payload);
    },
    removeComplaint({ commit }, value) {
      commit('removeComplaint', value);
    },
    moveUploadedEvidence({ commit }, complaint) {
      commit('moveUploadedEvidence', complaint);
    },
    setActiveComplaint({ commit }, payload) {
      commit('setActiveComplaint', payload);
    },
  },
  getters: {
    complaints: (state) => state.complaints,
    getArbSubmitInProgress: (state) => state.arbSubmitInProgress,
    getComplaintByQuestionId: (state, getters) => (questionId) => {
      const complaint = state.complaints.find((x) => x.questionId === questionId);
      if (complaint !== undefined) {
        return complaint;
      }
      return getters.getDefaultComplaint;
    },
    getDefaultComplaint: (state) => ({
      sectionId: state.complaintSection?.sectionId || 0,
      sectionName: state.complaintSection?.sectionName || '',
      questionId: state.complaintQuestion?.question_id || 0,
      questionTitle: state.complaintQuestion?.question_title || '',
      feedback: '',
      evidenceUploads: [],
      submitted: false,
    }),
    getOdometerInput: (state) => state.odometerInput,
    getActiveComplaint: (state) => state.activeComplaint,
  },
};
